import React from 'react';
import { number, string } from 'prop-types';
import styled from 'styled-components';

const Success = styled.span`
  font-weight: bold;
  color: #10ce64;
  display: flex;
  justify-content: center;

  @media(min-width: 1000px) {
    display: inline;
  }
`;

const pluralize = balance => ` ${balance} ${(balance === 1 ? 'anúncio' : 'anúncios')}`;

const HasBalance = ({ balance, text }) => (
  <p>
    {text}
    <Success>
      {pluralize(balance)}
    </Success>
  </p>
);

HasBalance.propTypes = {
  balance: number,
  text: string,
};

HasBalance.defaultProps = {
  balance: 0,
  text: null,
};

export default HasBalance;
